// extracted by mini-css-extract-plugin
export var about = "index-module--about--G3S4C";